export { default as genStyleUtils } from "./util/genStyleUtils";
export { default as genCalc } from "./util/calc";
export { default as statisticToken, merge as mergeToken, statistic } from "./util/statistic";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ant-design/cssinjs-utils/es/index.js
// module id = 633
// module chunks = 0